module.exports = "/_next/static/images/68c4cc07518d004d58f8fd86b4302d3f-purple-man@0.5x.jpg.webp";